define( [
	"../../core"
], function( jQuery ) {
	return jQuery.now();
} );



//////////////////
// WEBPACK FOOTER
// ./~/jquery/src/ajax/var/nonce.js
// module id = 149
// module chunks = 0